import { render, staticRenderFns } from "./TrainingZone.vue?vue&type=template&id=72a0666e&scoped=true"
import script from "./TrainingZone.vue?vue&type=script&lang=js"
export * from "./TrainingZone.vue?vue&type=script&lang=js"
import style0 from "./TrainingZone.vue?vue&type=style&index=0&id=72a0666e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0666e",
  null
  
)

export default component.exports